import { useEffect, useState } from 'react';
import { Accordion, AccordionSummary, Typography, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSearchParams } from 'react-router-dom';
import BadgeNumber from 'components/BadgeNumber';
import { Form3Section2Fields } from 'constants/form-3-section-2-fields';
import FormBuilder from 'containers/FormBuilder';
import { useController } from 'react-hook-form';
import CircularIcon from 'components/CircularIcon';
import DoneIcon from '@mui/icons-material/Done';
import BottomButton from 'components/BottomButton';

export default function FormStep3Section2Container() {
  const [searchParams] = useSearchParams();
  const section = searchParams.get('section') || '1';
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(false);
  const { fieldState, formState } = useController({ name: 'surat_kuasa.authorised_signatories' });

  useEffect(() => {
    setIsAccordionExpanded(section === '2');
  }, [section]);

  useEffect(() => {
    if (fieldState.error) {
      setIsAccordionExpanded(true);
    }
  }, [fieldState.error]);

  return (
    <Accordion
      expanded={isAccordionExpanded}
      onChange={() => ['2'].includes(section) && setIsAccordionExpanded((prev) => !prev)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
        {section <= '2' ? (
          <BadgeNumber>2</BadgeNumber>
        ) : (
          <CircularIcon>
            <DoneIcon />
          </CircularIcon>
        )}
        <Typography color="surface.700" variant="h6" sx={{ marginLeft: 1 }}>
          Penerima Kuasa
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{['2'].includes(section) && <FormBuilder formFields={Form3Section2Fields} />}</AccordionDetails>
      {section === '2' && <BottomButton isButtonLoading={formState.isSubmitting} />}
    </Accordion>
  );
}
